<template>
  <v-app style="background-color: rgb(242,242,242)">
    <v-main>
        <v-container>
          <v-flex class="text-center">
              <v-card-text class="black--text text-h4 red--text">{{ $t('error_404_sorry') }}</v-card-text>
              <v-card-text><v-btn color="green darken-2" dark @click="goBack">Go back</v-btn></v-card-text>
          </v-flex>
        </v-container>
    </v-main>
  </v-app>
</template>

<script>
  export default {
    name: "Error404",
    methods: {
      goBack() {
        this.$router.back()
      }
    }
  }
</script>

<style scoped>

</style>